const en = {
    LOADING: 'Loading...',
    VIDEO_LOAD_FAILED: 'Video failed to load.',
    VIDEO_RELOAD: 'Reload video',
    LOAD_FULL_VIDEO: 'Load full video',
    AUDIO_ONLY: 'Audio only — video not loaded',
    FULL_VIDEO_UNSUPPORTED: "Audio only — the full video can't be played in the browser",
    SUB_TEXT: 'Subtitle Text',
    OPEN_VIDEO: 'Open Video',
    OPEN_SUB: 'Open Subtitle',
    EXPORT_ASS: 'Export ASS',
    EXPORT_SRT: 'Export SRT',
    EXPORT_VTT: 'Export VTT',
    EXPORT_VIDEO: 'Export Video',
    TRANSLATE: 'Translation',
    TRANSLATING: 'Translation...',
    TRANSLAT_SUCCESS: 'Translation success',
    DECODE_START: 'Start decoding audio',
    DECODE_SUCCESS: 'Decoding audio success',
    DECODE_ERROR: 'Decoding audio failed',
    VIDEO_EXT_ERR: 'Unable to open this video format',
    SUB_EXT_ERR: 'Unable to open this subtitle format',
    MOBILE_TIP: 'Please use computer access',
    HOTKEY_01: 'Space: Play / Pause',
    HOTKEY_02: 'Ctrl + Z: Undo',
    CLEAR: 'Clear',
    UNDO: 'Undo',
    DELETE: 'Delete Subtitle',
    MERGE: 'Merge Next',
    SPLIT: 'Split Subtitle',
    LOADING_FFMPEG: 'Loading dependency...',
    LOADING_FONT: 'Loading font...',
    LOADING_VIDEO: 'Loading video...',
    LOADING_SUB: 'Loading subtitle...',
    CLEAR_TIP: 'Confirm that all data is cleared',
    BURN_ERROR: 'Burn subtitles failed',
    BURN_START: 'Start burn subtitles',
    BURN_SUCCESS: 'Burn subtitles success',
    OPEN_VIDEO_ERROR: 'Please open the video first',
};

const it = {
    LOADING: "Caricamento in corso...",
    VIDEO_LOAD_FAILED: 'Impossibile caricare il video.',
    VIDEO_RELOAD: 'Ricarica video',
    LOAD_FULL_VIDEO: 'Carica video completo',
    AUDIO_ONLY: 'Solo audio — video non caricato',
    FULL_VIDEO_UNSUPPORTED: "Solo audio — il video completo non può essere riprodotto nel browser",
    SUB_TEXT: "Sottotitoli",
    OPEN_VIDEO: "Apri video",
    OPEN_SUB: "Apri sottotitoli",
    EXPORT_ASS: "Esporta ASS",
    EXPORT_SRT: "Esporta SRT",
    EXPORT_VTT: "Esporta VTT",
    EXPORT_VIDEO: "Esporta video",
    TRANSLATE: 'Traduci',
    TRANSLATING: 'Traduzione...',
    TRANSLAT_SUCCESS: "Traduzione riuscita",
    DECODE_START: "Avvia decodifica audio",
    DECODE_SUCCESS: "Decodifica audio riuscita",
    DECODE_ERROR: "Decodifica audio non riuscita",
    VIDEO_EXT_ERR: "Impossibile aprire questo formato video",
    SUB_EXT_ERR: "Impossibile aprire questo formato di sottotitoli",
    MOBILE_TIP: "Utilizza l'accesso al computer",
    HOTKEY_01: "Spazio: Riproduci / Pausa",
    HOTKEY_02: "Ctrl + Z: Annulla",
    CLEAR: "Pulisci",
    UNDO: "Annulla",
    DELETE: "Elimina sottotitoli",
    MERGE: "Unisci dopo",
    SPLIT: "Dividi sottotitoli",
    LOADING_FFMPEG: "Caricamento dipendenza in corso...",
    LOADING_FONT: "Caricamento font in corso...",
    LOADING_VIDEO: "Caricamento video in corso...",
    LOADING_SUB: "Caricamento sottotitoli in corso...",
    CLEAR_TIP: "Conferma che tutti i dati siano stati cancellati",
    BURN_ERROR: "Masterizzazione sottotitoli non riuscita",
    BURN_START: "Avvia masterizzazione sottotitoli",
    BURN_SUCCESS: "Masterizzazione sottotitoli riuscita",
    OPEN_VIDEO_ERROR: "Apri prima il video",
};

const tr = {
    LOADING: 'Loading...',
    VIDEO_LOAD_FAILED: 'Video yüklenemedi.',
    VIDEO_RELOAD: 'Videoyu yeniden yükle',
    LOAD_FULL_VIDEO: 'Tam videoyu yükle',
    AUDIO_ONLY: 'Yalnızca ses — video yüklenmedi',
    FULL_VIDEO_UNSUPPORTED: "Yalnızca ses — tam video tarayıcıda oynatılamıyor",
    SUB_TEXT: 'Subtitle Text',
    OPEN_VIDEO: 'Video Aç',
    OPEN_SUB: 'Altyazı Aç',
    EXPORT_ASS: 'ASS Çıkar',
    EXPORT_SRT: 'SRT Çıkar',
    EXPORT_VTT: 'VTT Çıkar',
    EXPORT_VIDEO: 'Videoyu Çıkar',
    TRANSLATE: 'Çevir',
    TRANSLATING: 'Çevriliyor...',
    TRANSLAT_SUCCESS: 'Çevirme başarılı',
    DECODE_START: 'Ses çözümlemesi başladı',
    DECODE_SUCCESS: 'Ses çözümlemesi başarılı',
    DECODE_ERROR: 'Ses çözümlemesi başarısız',
    VIDEO_EXT_ERR: 'Bu video biçimi açılamıyor',
    SUB_EXT_ERR: 'Bu altyazı biçimi açılamıyor',
    MOBILE_TIP: 'Lütfen bilgisayardan erişin',
    HOTKEY_01: 'Boşluk: Oynat / Duraklat',
    HOTKEY_02: 'Ctrl + Z: Geri Al',
    CLEAR: 'Temizle',
    UNDO: 'Geri Al',
    DELETE: 'Altyazıyı Sil',
    MERGE: 'Sonrakiyle Birleştir',
    SPLIT: 'Altyazıyı Böl',
    LOADING_FFMPEG: 'Bağımlılık yükleniyor...',
    CLEAR_TIP: 'Tüm verilerin silineceğini onaylıyor musunuz?',
    BURN_ERROR: 'Altyazı gömme başarısız',
    BURN_START: 'Altyazı gömmeyi başlat',
    BURN_SUCCESS: 'Altyazı gömme başarılı',
    OPEN_VIDEO_ERROR: 'Lütfen önce videoyu açın',
};

const zh = {
    LOADING: '加载中...',
    VIDEO_LOAD_FAILED: '视频加载失败。',
    VIDEO_RELOAD: '重新加载视频',
    LOAD_FULL_VIDEO: '加载完整视频',
    AUDIO_ONLY: '仅音频 — 视频未加载',
    FULL_VIDEO_UNSUPPORTED: "仅音频 — 浏览器无法播放完整视频",
    SUB_TEXT: '字幕文本',
    OPEN_VIDEO: '打开视频',
    OPEN_SUB: '打开字幕',
    EXPORT_ASS: '导出 ASS',
    EXPORT_SRT: '导出 SRT',
    EXPORT_VTT: '导出 VTT',
    EXPORT_VIDEO: '导出视频',
    TRANSLATE: '批量翻译',
    TRANSLATING: '翻译中...',
    TRANSLAT_SUCCESS: '翻译成功',
    DECODE_START: '开始解码音频',
    DECODE_SUCCESS: '解码音频成功',
    DECODE_ERROR: '解码音频失败',
    VIDEO_EXT_ERR: '无法打开该视频格式',
    SUB_EXT_ERR: '无法打开该字幕格式',
    MOBILE_TIP: '请使用电脑访问',
    HOTKEY_01: '空格键: 播放 / 暂停',
    HOTKEY_02: 'Ctrl + Z: 撤销',
    CLEAR: '清空',
    UNDO: '撤销',
    DELETE: '删除字幕',
    MERGE: '合并下一个',
    SPLIT: '拆分字幕',
    LOADING_FFMPEG: '加载依赖中...',
    LOADING_FONT: '加载字体中...',
    LOADING_VIDEO: '加载视频中...',
    LOADING_SUB: '加载字幕中...',
    CLEAR_TIP: '确认清空所有数据吗',
    BURN_ERROR: '合成字幕失败',
    BURN_START: '开始合成字幕',
    BURN_SUCCESS: '合成字幕成功',
    OPEN_VIDEO_ERROR: '请先打开视频',
};

const i18n = {
    en,
    it,
    zh,
    'zh-cn': zh,
    'zh-tw': zh,
    tr,
};

export default i18n;
